import { render, staticRenderFns } from "./loadInfo.vue?vue&type=template&id=82a99f22&scoped=true&"
import script from "./loadInfo.vue?vue&type=script&lang=js&"
export * from "./loadInfo.vue?vue&type=script&lang=js&"
import style0 from "./loadInfo.vue?vue&type=style&index=0&id=82a99f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a99f22",
  null
  
)

export default component.exports